import { NewMatchCardSchema } from '@/views/sports/components/NewMatchCard/styles/NewMatchCard.styles';

export const newMatchCardStyles: NewMatchCardSchema = {
  boxWrapper: {
    borderRadius: 'lg',
    overflow: 'hidden',
    padding: '2px',
    fontFamily: 'body',
  },
  bodyStack: {
    p: 2,
    borderTopRadius: 'md',
    m: '1px',
    mb: '0',
    bg: 'alpha.900',
    fontWeight: 'bold',
  },
  titleHeading: {
    cursor: 'pointer',
    as: 'h5',
    textTransform: 'uppercase',
    textAlign: 'center',
    fontFamily: 'Staatliches',
    fontSize: 'sm',
    fontWeight: 'normal',
    color: 'white',
  },
  footerFlex: {
    as: 'footer',
    bg: '#8962f1',
    boxShadow: '0px 0px 4px 0px rgba(255, 255, 255, 0.10)',
    fontSize: '2xs',
    fontWeight: 'semibold',
    px: '2',
    py: '1',
    borderTop: '1px',
    borderColor: 'blackAlpha.500',
    fontFamily: 'accent',
    m: '1px',
    mt: '0',
    borderBottomRadius: 'base',
    alignItems: 'center',
    gap: '1',
  },
  footerStack: {
    direction: 'row',
  },
  footerStackDivider: {
    height: '2.5',
    borderColor: 'blackAlpha.400',
  },
  footerSportNameFlex: {
    align: 'center',
    gap: '1',
    maxW: '85%',
    w: 'fit-content',
    mr: '2',
  },
  footerSportNameIconSvg: {
    color: 'alpha.700',
    fontSize: 'md',
  },
  footerCompetitionNameText: {
    color: 'alpha.700',
    fontWeight: 'semibold',
    sx: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 'initial',
    },
  },
  footerCountDown: {
    sx: {
      '&&&.state-prior': {
        textTransform: 'uppercase',
      },
    },
    sxWrapper: {
      mr: 'auto',
    },
  },
  footerDuotoneSgmLogo: {
    h: 'auto',
    primaryColor: 'alpha.500',
    secondaryColor: 'beta.600',
    w: '10',
  },
  footerMatchLink: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: 'initial',
    fontWeight: 'semibold',
    color: 'white',
  },
  footerMatchLinkIcon: {
    color: 'white',
    fontSize: 'md',
  },
};
